import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LocalStorageService {
    constructor(@Inject(LOCAL_STORAGE) private storage: StorageService,private _httpClient: HttpClient) {}

    set(key, val): void {
        this.storage.set("_ct"+key, val);
    }

    setNoPref(key, val): void { //set w/o prefix _ct so it will not be included in clearAppcached user should delete it individual
        this.storage.set(key, val);
    }

    get(key): any {
        return this.storage.get(key);
    }

    getRetrieveIfNotFound(key,api):  Observable<any>  {
        var data =  this.storage.get(key);
        if(!data){
            return this._httpClient.get<any>(api);
        }
        return data;
    }

    remove(key):void{
        localStorage.removeItem(key);
    }

    clearAppCached(): void{
        var arr = [];
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).substring(0,3) == '_ct') {
                arr.push(localStorage.key(i));
            }
        }
        for (var i = 0; i < arr.length; i++) {
            localStorage.removeItem(arr[i]);
        }
    }
}